import React from 'react'
import papaParse from 'papaparse'
import {
  Card,
  CARD_THEME,
  Pagination,
  usePagination,
  Button,
  BUTTON_THEME,
  Modal,
} from '@st-operations/uikit/src/v2/index.js'
import { saveAs } from 'file-saver'

import GridTable from './grid-table/index.jsx'
import TableLoader from '_components/table-loader/index.jsx'
import ExpandButton from '_components/expand-button/index.jsx'
import { useModal } from '_hooks'

import { useEventFeedsContext } from '../../../context/index.jsx'

const MODAL_STYLES = {
  content: 'expanded-data-preview__container',
  childWrapper: 'expanded-data-preview__wrapper',
  innerWrapper: 'expanded-data-preview__inner-wrapper',
}

const DataPreview = (props) => {
  const expand = useModal(false)
  const {
    schema,
    data: { name, attributes },
  } = useEventFeedsContext()
  const itemsPerPage = expand.isOpen ? 13 : 10
  const { page, toPage } = usePagination(props.tableData, itemsPerPage, 0)
  const options = new Array(page.quantity).fill(null).map((_, index) => index + 1)

  const handleDownloadCSV = () => {
    const fields = (props.tableColumns || []).map((column) => {
      return column.key
    })
    const tableCSV = papaParse.unparse({
      fields,
      data: props.tableData,
    })
    const blob = new Blob([tableCSV], { type: 'text/csv;charset=utf-8' })
    saveAs(blob, 'dataPreview.csv')
  }

  const handleDownloadSchema = () => {
    const fields = ['Group', 'Field', 'Description']
    const data = Object.keys(schema.attributes)
      .filter((key) => key !== 'default')
      .map((group) =>
        Object.keys(schema.attributes[group])
          .map((field) => {
            return [group, field, schema.attributes[group][field].description]
          })
          .filter((row) => attributes.includes(row[1]))
      )

    const tableCSV = papaParse.unparse({
      fields,
      data: data.flat(),
    })
    const blob = new Blob([tableCSV], { type: 'text/csv;charset=utf-8' })
    saveAs(blob, `${name || ''} Attr Schema.csv`)
  }

  const handleDownloadJson = () => {
    const jsonString = JSON.stringify(props.objectData, null, 4)
    const blob = new Blob([jsonString], {
      type: 'application/json;charset=utf-8',
    })
    saveAs(blob, 'dataPreview.json')
  }

  const Content = () => (
    <>
      <div className="scale-and-coverage__data-preview__header">
        <h3>Data Preview</h3>
        <h4>
          Sample of {props.tableData.length} rows. Total rows: {props.totalEvents}
        </h4>
        <ExpandButton
          onClick={expand.isOpen ? expand.handleCloseModal : expand.handleOpenModal}
          isExpanded={expand.isOpen}
        />
      </div>
      <If condition={!props.loading && !props.loadingDataPreview}>
        <div className="scale-and-coverage__grid-table-container">
          <GridTable
            className="scale-and-coverage__grid-table"
            columns={props.filteredColumns}
            data={page.content}
            emptyMessage="You need to add attributes to your feed in order to see the data preview"
          />
        </div>
        {props.filteredColumns.length > 0 && (
          <div className="scale-and-coverage__grid-table-footer">
            <div>
              <Button
                onClick={handleDownloadCSV}
                theme={BUTTON_THEME.GRAY}
                className="data-preview__download"
              >
                Download CSV
              </Button>
              <Button
                onClick={handleDownloadJson}
                theme={BUTTON_THEME.GRAY}
                className="data-preview__download"
              >
                Download JSON
              </Button>
              <Button
                onClick={handleDownloadSchema}
                theme={BUTTON_THEME.GRAY}
                className="data-preview__download"
              >
                Download Data Schema
              </Button>
            </div>
            <Pagination
              options={options}
              page={page.number - 1}
              onPageChange={({ value }) => toPage(value)}
            />
          </div>
        )}
      </If>
      <If condition={props.loading || props.loadingDataPreview}>
        <TableLoader className="scale-and-coverage__table-loader" />
      </If>
    </>
  )

  return (
    <Card theme={CARD_THEME.NO_SHADOW} className="scale-and-coverage__data-preview">
      <Modal
        classes={MODAL_STYLES}
        className="expanded-data-preview"
        isOpen={expand.isOpen}
        noCloseButton
        onClose={() => {}}
      >
        <Content />
      </Modal>
      <Content />
    </Card>
  )
}

export default DataPreview
